import React from "react";

export const EyeIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-4 h-4 text-gray-100",
    ...props
}) => {
    return (

        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
            <path d="M10.3866 7.99995C10.3866 9.31995 9.31995 10.3866 7.99995 10.3866C6.67995 10.3866 5.61328 9.31995 5.61328 7.99995C5.61328 6.67995 6.67995 5.61328 7.99995 5.61328C9.31995 5.61328 10.3866 6.67995 10.3866 7.99995Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.9999 13.5138C10.3532 13.5138 12.5466 12.1271 14.0732 9.72713C14.6732 8.78713 14.6732 7.20713 14.0732 6.26713C12.5466 3.86713 10.3532 2.48047 7.9999 2.48047C5.64656 2.48047 3.45323 3.86713 1.92656 6.26713C1.32656 7.20713 1.32656 8.78713 1.92656 9.72713C3.45323 12.1271 5.64656 13.5138 7.9999 13.5138Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};
